<div *ngIf="configurationsByInterval" class="recent-wrapper" >
  <div *ngFor="let key of configurationsByInterval; trackBy: trackInterval" class="recents-interval">
    <h4 *ngIf="key[0] != null" class="text-uppercase start-search-header border-box">{{translatedIntervals.get(key[0])}}</h4>
    <configuration-link-control *ngFor="let kvp of key[1]; trackBy: trackConf" [confSessionId]="kvp[0]" [conf]="kvp[1]" [searchSessionId]="searchSessionId"></configuration-link-control>
  </div>

  <div class="d-block text-right">
    <a role="button" class="text-uppercase mt-3" (click)="showMore()">{{strings.More}}...</a>
  </div>
</div>